<template>
  <el-radio-button v-bind="$attrs"> <slot /> </el-radio-button>
</template>

<script>
export default {
  name: 'RtRadioButton'
};
</script>



// WEBPACK FOOTER //
// rtRadioButton.vue?6085ef8e